export interface GrupoParametrosPlanilla {
  idGrupo: number;
  nombre: string;
  descripcion: string | null;
  orden: number;
  parametros: ParametroBaseCalculo[];
}

export interface ParametroBaseCalculo {
  idParametro: number;
  idGrupo: number;
  clave: string;
  descripcion: string;
  tipo: string;
  valorDefecto: string | null;
  orden: number;
  activo: boolean;
  grupo?: GrupoParametrosPlanilla;
}

export interface BaseCalculoPlanilla {
  idBaseCalculo: number;
  clave: string;
  nombre: string;
  descripcion: string | null;
  formula: string;
  esBaseImponible: boolean;
  activo: boolean;
  orden: number;
}

export interface FormulaValidationResult {
  isValid: boolean;
  error: string | null;
  testResult: unknown;
  usedVariables: string[];
  missingVariables: string[];
}

export interface FormulaFunction {
  name: string;
  description: string;
  syntax: string;
  example: string;
  category: string;
  parameters: FormulaFunctionParam[];
}

export interface FormulaFunctionParam {
  name: string;
  type: string;
  description: string;
  optional: boolean;
}

export const initialBaseCalculo: BaseCalculoPlanilla = {
  idBaseCalculo: 0,
  clave: '',
  nombre: '',
  descripcion: '',
  formula: '',
  esBaseImponible: false,
  activo: true,
  orden: 0,
};
